/**
 * Add CSS classes to a DOM node
 */
export const addClass = (
  node: HTMLElement | null,
  classes: string | undefined
): void => {
  if (node && classes) {
    classes.split(' ').forEach(c => {
      if (c) node.classList.add(c)
    })
  }
}

/**
 * Remove CSS classes from a DOM node
 */
export const removeClass = (
  node: HTMLElement | null,
  classes: string | undefined
): void => {
  if (node && classes) {
    classes.split(' ').forEach(c => {
      if (c) node.classList.remove(c)
    })
  }
}
